import React from "react";
import loadable from "../utils/loadable";
import Loading from "../components/Loading";

// Landing Page
export const Landing = loadable(() => import("./Landing"), {
  fallback: <Loading />
});
// Home Page
export const Home = loadable(() => import("./Pages/Home"), {
  fallback: <Loading />
});

// Home Page
export const GetStartedBtn = loadable(
  () => import("./Pages/Home/GetStartedBtn"),
  {
    fallback: <Loading />
  }
);

// // About Page
// export const About = loadable(() => import("./Pages/About"), {
//   fallback: <Loading />
// });
// Privacy Page
export const Privacy = loadable(() => import("./Pages/Privacy"), {
  fallback: <Loading />
});
// KYC Policy Page
export const KycPolicy = loadable(() => import("./Pages/KycPolicy"), {
  fallback: <Loading />
});
// AML Policy Page
export const AmlPolicy = loadable(() => import("./Pages/AmlPolicy"), {
  fallback: <Loading />
});
// Terms Page
export const Terms = loadable(() => import("./Pages/Terms"), {
  fallback: <Loading />
});
// Cancellation Page
// export const Cancellation = loadable(() => import("./Pages/Cancellation"), {
//   fallback: <Loading />
// });
// Shipping Page
export const Shipping = loadable(() => import("./Pages/Shipping"), {
  fallback: <Loading />
});
// // Contact Page
// export const Contact = loadable(() => import("./Pages/Contact"), {
//   fallback: <Loading />,
// });
// Vision Page
export const Vision = loadable(() => import("./Pages/Vision"), {
  fallback: <Loading />
});
// Vision Page
export const FortunX = loadable(() => import("./Pages/Solution/FortunX"), {
  fallback: <Loading />
});
// Gaming Page
export const Gaming = loadable(() => import("./Pages/Solution/Gaming"), {
  fallback: <Loading />
});
// Klethesia Page
export const Klethesia = loadable(() => import("./Pages/Solution/Klethesia"), {
  fallback: <Loading />
});
// Sattva shuffle Page
export const Sattvashuffle = loadable(
  () => import("./Pages/Solution/Sattvashuffle"),
  {
    fallback: <Loading />
  }
);
// Eco system Page
export const EcoSystem = loadable(() => import("./Pages/EcoSystem"), {
  fallback: <Loading />
});

// Eco system Page
// export const TeamAndPartners = loadable(
//   () => import("./Pages/TeamAndPartners"),
//   {
//     fallback: <Loading />
//   }
// );

// Validator Page
export const Validator = loadable(() => import("./Validator"), {
  fallback: <Loading />
});

// Blog Page
export const Blog = loadable(() => import("./Pages/Blog"), {
  fallback: <Loading />
});

// Blog Details Page
export const BlogDetails = loadable(() => import("./Pages/BlogDetails"), {
  fallback: <Loading />
});

// News Page
export const News = loadable(() => import("./Pages/News"), {
  fallback: <Loading />
});

// News Details Page
export const NewDetails = loadable(() => import("./Pages/NewDetails"), {
  fallback: <Loading />
});

// Static Pages
export const NotFound = loadable(() => import("./NotFound"), {
  fallback: <Loading />
});

// Block Validation Process Page
export const BlockValidationProcess = loadable(
  () => import("../components/BlockValidationProcess"),
  {
    fallback: <Loading />
  }
);
// Dao and Mst Chain Page
export const DaoAndMstChain = loadable(
  () => import("../components/DaoAndMstChain"),
  {
    fallback: <Loading />
  }
);
// Fractional Node
export const FractionalNode = loadable(
  () => import("../components/FractionalNode"),
  {
    fallback: <Loading />
  }
);
// Evm
export const Evm = loadable(() => import("../components/Evm"), {
  fallback: <Loading />
});

// Contact Us Page
export const ContactUs = loadable(() => import("./Pages/ContactUs"), {
  fallback: <Loading />
});
// // About Us Page
// export const AboutUs = loadable(() => import("./Pages/AboutUs"), {
//   fallback: <Loading />
// });
// // About Us Page
// export const AboutW = loadable(() => import("./Pages/About"), {
//   fallback: <Loading />
// });
// Event Page
export const Event = loadable(() => import("./Pages/Event"), {
  fallback: <Loading />
});

//BuildWithMst Page
export const BuildWithMst = loadable(() => import("./Pages/BuildWithMst"), {
  fallback: <Loading />
});

//BuildWithMst Page
// export const Contacts = loadable(() => import("./Pages/Contact"), {
//   fallback: <Loading />
// });

// Transparency
export const Transparency = loadable(
  () => import("../components/Transparency"),
  {
    fallback: <Loading />
  }
);

// Privacy Policy Page
export const PrivacyPolicy = loadable(
  () => import("../components/PrivacyPolicy"),
  {
    fallback: <Loading />
  }
);

// Terms And Condition Page
export const TermsAndConditions = loadable(
  () => import("../components/TermsAndCondition"),
  {
    fallback: <Loading />
  }
);

// Cancellation Page
export const CancellationW = loadable(() => import("./Pages/Cancellation"), {
  fallback: <Loading />
});

// DynamicComp
export const DynamicComp = loadable(() => import("../components/DynamicComp"), {
  fallback: <Loading />
});

// Build On Mst
export const BuildOnMST = loadable(() => import("../components/BuildOnMST"), {
  fallback: <Loading />
});

// Mst Research Program
export const MstResearchProgram = loadable(
  () => import("../components/MstResearchProgram"),
  {
    fallback: <Loading />
  }
);

// About
export const AboutNew = loadable(() => import("../components/About"), {
  fallback: <Loading />
});
